import React, {useState, useEffect, useContext} from "react";
// import Link from "next/link";
import { Button } from "@chakra-ui/button";
import { useSession } from "next-auth/client";
import { removeDuplicates } from "utils/tweetUtils";
import { useColorModeValue, useColorMode } from "@chakra-ui/color-mode";
import {
    Box,
    Flex,
    Text,
    useMediaQuery,
    useDisclosure,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Image,
    Center,
    Link,
} from "@chakra-ui/react";
import { firebaseClient, getToken } from "firebaseClient";
import { useRouter } from "next/dist/client/router";
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { TweetBar } from "components/queue-panels/tweet-bar";
import PuffLoader from "react-spinners/PuffLoader";
import { TweetContext } from "context/tweetContext";
import { CreatorListItem } from "components/scheduler/creatorListItem";
import { fetchContracts } from "controllers/ghostController";

let tabs = [
    "Personal information",
    "My services",
    "My reviews",
]

export const GhostwriterPanel = () => {

    const { colorMode, toggleColorMode } = useColorMode();
    const router = useRouter();
    const [session, loading] = useSession();
    const isAuthenticated = useFirebaseUser();
    const [isTooSmall] = useMediaQuery("(max-width: 600px)");

    const [isUpdating, setIsUpdating] = React.useState(false);
    const [twUserName, setTwUserName] = React.useState("");
    const [reviews, setReviews] = React.useState<any>([]);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isLoading, setIsLoading] = React.useState(false);
    const [refresh, refresher] = React.useState({});

    const [tweetsPending, setTweetsPending] = useState<any[]>([]);
    const [tweetsReady, setTweetsReady] = useState<any[]>([]);
    const [tweetsRejected, setTweetsRejected] = useState<any[]>([]);
    const [tweetsPublished, setTweetsPublished] = useState<any[]>([]);
    const [tweets, setTweets] = useState<any[]>([]);
    const [tweetsFiltered, setTweetsFiltered] = useState<any[]>([]);
    const tweetContext: any = useContext(TweetContext);
    const [selectedCreator, setSelectedCreator] = useState<any>(undefined);
    
    const [contracts, setContracts] = React.useState<any>([]);
    const [clients, setClients] = React.useState([]);

    const tweetbarBg = useColorModeValue("blue.50", "blue.900");
    const threadBg = useColorModeValue("purple.100", "purple.700");

    const getTweets = async function () {
        setIsLoading(true);
        // const response = await fetch('/api/ghostwriting/getWritingTweets?id=' + session?.user?.uid, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //         tokenUserId: session?.user?.uid,
        //         token: await getToken(session, "getGhostwriters"),
        //     }),
        // });
        // const json = await response.json();
        // console.log(json);

        const db = firebaseClient.firestore();
        let docs = await db.collectionGroup("tweets").where("ghostwriterId", "==", session?.user?.uid).get();
        let tweets = docs.docs.map(x => x.data());

        // console.log("getTweets - org: " + session?.user?.data?.subscription?.org);
        if (session?.user?.data?.subscription?.org && session?.user?.data?.subscription?.orgRole !== "Member") {
            let docsOrg = await db.collectionGroup("tweets").where("ghostwriterIdOrg", "==", session?.user?.data?.subscription?.org).get();
            let tweetsOrg = docsOrg.docs.map(x => x.data());
            tweets = tweets.concat(tweetsOrg);
        }
        
        console.log('tweets:', tweets);
        tweets = removeDuplicates(tweets, "id");

        tweets.forEach(tw => {
            if (tw.statusGhost === "rejected") tw.priority = 3;
            else if (tw.statusGhost === "pending") tw.priority = 1;
            else if (tw.statusGhost === "done") tw.priority = 0;
            else tw.priority = 2;
        });

        // sort by statusGhost
        tweets = tweets.sort((a, b) => b.priority - a.priority);


        if (tweets?.length) {
            // setTweetsPending(tweets.filter(x => x.statusGhost == "pending"));
            // setTweetsReady(tweets.filter(x => x.statusGhost == "ready"));
            // setTweetsRejected(tweets.filter(x => x.statusGhost == "rejected"));
            // setTweetsPublished(tweets.filter(x => x.statusGhost == "done" || x.status == "sent" || x.status == "scheduled"));
            // tweets = [];
            setTweets(tweets);
            filterTweets(tweets);
        }
        setIsLoading(false);
    }

    const filterTweets = function (tweets) {
        let filtered = tweets;
        if (selectedCreator?.id) {
            filtered = tweets.filter(x => x.idAccount == selectedCreator.id);
        }
        setTweetsFiltered(filtered);
    }

    const getContracts = async () => {
        console.log("getContracts");
        let allContracts = await fetchContracts(session, "ghostwriter");

        let newClientsList = session?.user?.data?.linkAccounts ?? [];
        allContracts.forEach(contract => {
            newClientsList.push(contract.client);
        });
        newClientsList = removeDuplicates(newClientsList, "id");
        setContracts(allContracts);
        setClients(newClientsList);
      }

    useEffect(() => {
        if (isAuthenticated) {
            setClients(session?.user?.data?.linkAccounts ?? []);
            getTweets();
            getContracts();
        }
    }, [isAuthenticated, tweetContext.refresh]);

    useEffect(() => {
        filterTweets(tweets);
    }, [selectedCreator]);


    // console.log(countryList());
    // console.log("-" + data.country + "-");

    let selectedCreatorContract = contracts?.find(c => c?.client?.id == selectedCreator?.id && c.status == "running");

    return (
        <Box>
            {
                (session?.user?.data?.ghostwriterData || session?.user?.data?.isBeta) && (
                    <Flex justifyContent="flex-end" alignItems="center" w="100%" mt="0" pb={0}>
                        <Flex>
                            <Button
                                variant={"secondary"}
                                // size="sm"
                                as={Link}
                                href="/ghostwriter"
                            >
                                Ghostwriting Settings (beta)
                            </Button>
                        </Flex>
                    </Flex>
                )
            }
            {
                tweets?.length > 0 && (
                    <Flex justifyContent="space-between" alignItems="center" w="100%" mt="4" pb={4}>
                        {/* <Text fontSize="lg" fontWeight="700">
                            All content sent to clients
                        </Text> */}
                        <Flex>
                            <Menu
                                // variant="secondary"
                            >
                                <MenuButton
                                    as={Button}
                                    mr={3}
                                    variant="secondary"
                                    rightIcon={<ChevronDownIcon />}
                                >
                                    <Flex alignItems="center">
                                        {selectedCreator?.twUserName && <Image src={selectedCreator.image ?? "/assets/resources/emptyProfile.png"} w="6" h="6" rounded="full" />}
                                        <Text noOfLines={1} wordBreak="break-all" w="120px" ml={selectedCreator?.twUserName ? 2 : 0}>{selectedCreator?.twUserName ? "@" + selectedCreator?.twUserName : "All creators"}</Text>
                                    </Flex>
                                </MenuButton>
                                <MenuList maxH="215px" overflow="scroll">
                                    <MenuItem
                                        as={Box}
                                        key={"creator"}
                                        onClick={() => {
                                            setSelectedCreator({});
                                        }}
                                    >
                                        All clients
                                    </MenuItem>
                                    {clients?.map((creator, index) => (
                                        <MenuItem
                                            as={Box}
                                            key={"creator-" + index}
                                            onClick={() => {
                                                setSelectedCreator(creator);
                                            }}
                                        >
                                            <CreatorListItem creator={creator} index={index} />
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </Menu>
                            {
                                !!selectedCreatorContract && (
                                    <Button as="a" href="/ghostwriter?tab=My+contracts"
                                        variant={"secondary"}
                                    >
                                        Contract
                                    </Button>
                                )
                            }
                            {
                                !!selectedCreatorContract?.contentPlanUrl && (
                                    <Button as="a" 
                                        ml={2}
                                        href={selectedCreatorContract?.contentPlanUrl}
                                        target="_blank"
                                        variant={"secondary"}
                                    >
                                        Content Plan
                                    </Button>
                                )
                            }
                        </Flex>
                        <Flex>
                            {
                                selectedCreator?.id && (
                                    <Button
                                        variant="tertiaryNoBackground"
                                        color="gray.500"
                                        fontWeight={400}
                                        as="a"
                                        target="_blank"
                                        href={"https://tweethunter.io/write?handle=" + selectedCreator?.twUserName}
                                    >
                                        + write for @{selectedCreator?.twUserName}
                                    </Button>
                                )
                            }
                        </Flex>
                    </Flex>
                )
            }
            {
                tweetsFiltered?.length > 0 && (
                    <Flex flexDir="column">
                        {
                            tweetsFiltered.map((tweet) => (
                                <TweetBar
                                    key={tweet.id}
                                    type="ghost"
                                    tweet={tweet}
                                    isGhostwriter={true}
                                    disableIcon={true}
                                    disableGhostInfo={true}
                                />
                            ))
                        }
                    </Flex>
                )
            }
            {
                isLoading ? (
                    <Center pt={20} w="100%">
                        <PuffLoader color={"hsl(203, 100%, 36%)"} loading={true} css="display: block; margin: 0 auto; border-color: red;" size={50} />
                    </Center>
                ) : (
                    tweetsFiltered?.length == 0 && (
                            <Text mt={20}
                                textStyle="body.medium.standard"
                            >Ask your clients to give you their personal link to start writing for them</Text>
                    )
                )
            }
        </Box>
    );
};  
